import styled, { css } from "styled-components";
import BackgroundLayout from "../BackgroundLayout/BackgroundLayout";
import BoyBagsBackground from "../../../../assets/images/boy-bags-bg.png";

export const BackgroundLayoutWithLogoRoot = styled(BackgroundLayout)(
    () => css`
        .logo-icon {
            width: 45vw;
            max-width: 15rem;
            height: auto;
        }
        background-image: url(${BoyBagsBackground});
        background-size: cover;
        background-position: top;
        background-repeat: no-repeat;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    `,
);
